var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseCase23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2813 11.3363H10.7188C10.1042 11.3363 9.60547 10.8376 9.60547 10.223V1.11524C9.60547 0.500705 10.1042 0.00195312 10.7188 0.00195312H84.2813C84.8958 0.00195312 85.3946 0.500705 85.3946 1.11524V10.223C85.3951 10.8376 84.8958 11.3363 84.2813 11.3363ZM11.832 9.10974H83.1686V2.22852H11.832V9.10974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8628 59.4722H13.7539C13.1394 59.4722 12.6406 58.9729 12.6406 58.3589V10.2227C12.6406 9.60813 13.1394 9.10938 13.7539 9.10938H22.8628C23.4773 9.10938 23.9761 9.60813 23.9761 10.2227V58.3589C23.9761 58.9734 23.4773 59.4722 22.8628 59.4722ZM14.8672 57.245H21.7495V11.3359H14.8672V57.245Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8629 18.6934H13.754C12.2884 18.6934 12.2884 16.4668 13.754 16.4668H22.8629C24.3286 16.4668 24.3286 18.6934 22.8629 18.6934Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8629 27.0488H13.754C12.2884 27.0488 12.2884 24.8223 13.754 24.8223H22.8629C24.3286 24.8223 24.3286 27.0488 22.8629 27.0488Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8629 35.4043H13.754C12.2884 35.4043 12.2884 33.1777 13.754 33.1777H22.8629C24.3286 33.1777 24.3286 35.4043 22.8629 35.4043Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8629 43.7617H13.754C12.2884 43.7617 12.2884 41.5352 13.754 41.5352H22.8629C24.3286 41.5352 24.3286 43.7617 22.8629 43.7617Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.863 52.1172H13.7541C12.289 52.1172 12.289 49.8906 13.7541 49.8906H22.863C24.3286 49.8906 24.3286 52.1172 22.863 52.1172Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4995 73.426H8.50049C7.88596 73.426 7.38721 72.9267 7.38721 72.3127V58.3594C7.38721 57.7448 7.88596 57.2461 8.50049 57.2461H86.4995C87.114 57.2461 87.6128 57.7454 87.6128 58.3594V72.3127C87.6133 72.9273 87.114 73.426 86.4995 73.426ZM9.61378 71.1989H85.3862V59.4727H9.61378V71.1989Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2449 59.4722H72.1377C71.5232 59.4722 71.0244 58.9729 71.0244 58.3589V10.2227C71.0244 9.60813 71.5237 9.10938 72.1377 9.10938H81.2449C81.8595 9.10938 82.3582 9.60813 82.3582 10.2227V58.3589C82.3593 58.9734 81.8595 59.4722 81.2449 59.4722ZM73.2521 57.245H80.1316V11.3359H73.2521V57.245Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2448 18.6934H72.1376C70.672 18.6934 70.6725 16.4668 72.1376 16.4668H81.2448C82.7105 16.4668 82.7105 18.6934 81.2448 18.6934Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2448 27.0488H72.1376C70.672 27.0488 70.6725 24.8223 72.1376 24.8223H81.2448C82.7105 24.8223 82.7105 27.0488 81.2448 27.0488Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2448 35.4043H72.1376C70.672 35.4043 70.6725 33.1777 72.1376 33.1777H81.2448C82.7105 33.1777 82.7105 35.4043 81.2448 35.4043Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2448 43.7617H72.1376C70.672 43.7617 70.6725 41.5352 72.1376 41.5352H81.2448C82.7105 41.5352 82.7105 43.7617 81.2448 43.7617Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2448 52.1172H72.1376C70.672 52.1172 70.6725 49.8906 72.1376 49.8906H81.2448C82.7099 49.8906 82.7099 52.1172 81.2448 52.1172Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4966 73.4273C62.8821 73.4273 62.3833 72.928 62.3833 72.314V67.4434H32.6157V72.314C32.6157 73.7796 30.3892 73.7791 30.3892 72.314V66.3301C30.3892 65.7155 30.8879 65.2168 31.5024 65.2168H63.496C64.1106 65.2168 64.6093 65.7161 64.6093 66.3301V72.314C64.6099 72.9285 64.1106 73.4273 63.496 73.4273H63.4966Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6196 87.1758H24.381C22.9153 87.1758 22.9153 84.9492 24.381 84.9492H70.6196C72.0847 84.9492 72.0847 87.1758 70.6196 87.1758Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6196 79.3535H24.381C22.9153 79.3535 22.9153 77.127 24.381 77.127H70.6196C72.0847 77.127 72.0847 79.3535 70.6196 79.3535Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6196 94.9981H24.381C22.9153 94.9981 22.9153 92.7715 24.381 92.7715H70.6196C72.0847 92.7715 72.0847 94.9981 70.6196 94.9981Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1375 16.6309H22.8629C21.3973 16.6309 21.3973 14.4043 22.8629 14.4043H72.1375C73.6031 14.4043 73.6031 16.6309 72.1375 16.6309Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2271 22.2993C32.6125 22.2993 32.1138 21.8006 32.1138 21.186V15.5172C32.1138 14.0516 34.3403 14.0516 34.3403 15.5172V21.186C34.3403 21.8006 33.8416 22.2993 33.2271 22.2993Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1574 22.2988H30.2965C28.8309 22.2988 28.8309 20.0723 30.2965 20.0723H36.1574C37.6225 20.0723 37.6236 22.2988 36.1574 22.2988Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 22.2993C46.8855 22.2993 46.3867 21.8006 46.3867 21.186V15.5172C46.3867 14.0516 48.6133 14.0516 48.6133 15.5172V21.186C48.6133 21.8006 48.1145 22.2993 47.5 22.2993Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4309 22.2988H44.5694C43.1038 22.2988 43.1038 20.0723 44.5694 20.0723H50.4309C51.8965 20.0723 51.8965 22.2988 50.4309 22.2988Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7734 22.2993C61.1589 22.2993 60.6602 21.8006 60.6602 21.186V15.5172C60.6602 14.0516 62.8867 14.0516 62.8867 15.5172V21.186C62.8867 21.8006 62.388 22.2993 61.7734 22.2993Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7036 22.2988H58.8427C57.377 22.2988 57.3776 20.0723 58.8427 20.0723H64.7036C66.1692 20.0723 66.1692 22.2988 64.7036 22.2988Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4496 59.4719C34.8351 59.4719 34.3364 58.9726 34.3364 58.3586V39.6582H22.8634C21.3978 39.6582 21.3978 37.4316 22.8634 37.4316H35.4496C36.0642 37.4316 36.5629 37.9304 36.5629 38.5449V58.3575C36.5629 58.9732 36.0642 59.4719 35.4496 59.4719Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1569 48.0278C24.5128 48.0278 24.5128 40.9707 29.1569 40.9707C33.8015 40.9707 33.801 48.0278 29.1569 48.0278ZM29.1569 43.1967C27.4419 43.1967 27.443 45.8012 29.1569 45.8012C30.8702 45.8012 30.8713 43.1967 29.1569 43.1967Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1569 55.9366C24.5134 55.9366 24.5123 48.8789 29.1569 48.8789C33.8015 48.8789 33.801 55.9366 29.1569 55.9366ZM29.1569 51.1055C27.4419 51.1055 27.443 53.71 29.1569 53.71C30.8702 53.71 30.8713 51.1055 29.1569 51.1055Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5503 59.4733C58.9358 59.4733 58.437 58.974 58.437 58.36V38.5469C58.437 37.9323 58.9363 37.4336 59.5503 37.4336H72.1377C73.6033 37.4336 73.6027 39.6602 72.1377 39.6602H60.6636V58.3595C60.6636 58.9751 60.1648 59.4739 59.5503 59.4739V59.4733Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8434 48.0278C61.1988 48.0278 61.1999 40.9707 65.8434 40.9707C70.4886 40.9707 70.488 48.0278 65.8434 48.0278ZM65.8434 43.1967C64.1289 43.1967 64.1301 45.8012 65.8434 45.8012C67.5579 45.8012 67.5579 43.1967 65.8434 43.1967Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8434 55.9366C61.1993 55.9366 61.1993 48.8789 65.8434 48.8789C70.4886 48.8789 70.488 55.9366 65.8434 55.9366ZM65.8434 51.1055C64.1289 51.1055 64.1301 53.71 65.8434 53.71C67.5579 53.71 67.5579 51.1055 65.8434 51.1055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCase23);
export default __webpack_public_path__ + "static/media/useCase2_3.9f20964ab2b51b8d4e5f0c09c5b9d252.svg";
export { ForwardRef as ReactComponent };